import user from "./user";
import memo from "./memo";
import article from "./article";
import url from "./url";
import catelog from "./catelog";
import translate from "./translate";
import website from "./website";

export default {
  user,
  memo,
  article,
  url,
  catelog,
  translate,
  website
};
